import { render } from "./SelectItems.vue?vue&type=template&id=16e371d7"
import script from "./SelectItems.vue?vue&type=script&lang=js"
export * from "./SelectItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__